import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Category from '@mui/icons-material/Category';
import axios from 'axios';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getcommodity } from '../redux/commodity';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const dispatch = useDispatch();
  const agent = useSelector((state) => state.agent);
  const commodity = useSelector((state) => state.commodity);
  const [open, setOpen] = React.useState(false);
  const [selectedAgent, setSelectedAgent] = React.useState("none");
  const [unit, setUnit] = React.useState("none");
  const [personName, setPersonName] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const dt = new Date();
  const idmain = `${dt.getHours()}C${dt.getFullYear()}M${String(dt.getMonth() + 1).padStart(2, '0')}${dt.getMinutes()}0D${dt.getSeconds()}${commodity.length % dt.getUTCDate()}`;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const names = [
    "Maize",
    "Soya Beans",
    "Onion",
    "Pepper",
    "Tomatoes",
    "Rice",
  ];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const resetForm = () => {
    document.getElementById("amount").value = "";
    document.getElementById("expecteddate").value = "";
    document.getElementById("qty").value = "";
    document.getElementById("prefinancedate").value = "";
    document.getElementById("others").value = "";
    setSelectedAgent("none");
    setUnit("none");
    setPersonName([]);
  };

  const addCommodity = async () => {
    setLoading(true);
    try {
      const response = await axios.post("https://embert.sisrevolution.com/api/commodity/addcommodity/", {
        batch: idmain,
        agent: selectedAgent,
        amountgiven: document.getElementById("amount").value,
        expecteddate: document.getElementById("expecteddate").value,
        qty: document.getElementById("qty").value,
        prefinancedate: document.getElementById("prefinancedate").value,
        others: document.getElementById("others").value,
        unit: unit,
        product: personName,
      });

      if (response.status === 200) {
        dispatch(getcommodity({ data: response.data }));
        handleSnackbarOpen("Commodity Added Successfully", "success");
        resetForm();
        handleClose();
      } else {
        handleSnackbarOpen("Failed to Add Commodity", "error");
      }
    } catch (err) {
      handleSnackbarOpen("Error Adding Commodity", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>
        Pre-Finance
      </Button>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Pre-Finance
          <IconButton onClick={handleClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
            onSubmit={(e) => { e.preventDefault(); addCommodity(); }}
          >
            <TextField
              id="batch"
              label="Batch Number"
              type="text"
              value={idmain}
              disabled
              autoComplete="current-text"
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Choose Agent</InputLabel>
              <Select
                value={selectedAgent}
                onChange={(e) => setSelectedAgent(e.target.value)}
                label="Choose Agent"
                required
              >
                <MenuItem value="none">Choose Agent</MenuItem>
                {agent.map((list) => (
                  <MenuItem key={`${list.surname} ${list.lastname}`} value={list.idnumber}>
                    {`${list.surname} ${list.othername}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="amount"
              label="Amount Given"
              type="number"
              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
              }}
              required
            />
            <TextField
              id="expecteddate"
              label="Expected Supply Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              required
            />
            <TextField
              id="qty"
              label="Quantity of Pre-finance"
              type="number"
              autoComplete="current-text"
              required
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Unit of Measurement</InputLabel>
              <Select
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                label="Unit of Measurement"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Kg">Kg</MenuItem>
                <MenuItem value="bags">Bags</MenuItem>
                <MenuItem value="tons">Tons</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Choose Products</InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Choose Products" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
                required
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="prefinancedate"
              label="Date Pre-financed"
              type="date"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              required
            />
            <TextField
              id="others"
              label="Other Information"
              multiline
              rows={4}
              sx={{ m: 1, width: '52ch' }}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Box sx={{ textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" disabled>Loading...</Button>
            ) : (
              <Button
                type="submit"
                variant="outlined"
                startIcon={<Category />}
                size="large"
                sx={{ bgcolor: '#e0eff9', color: '#1976d2' }}
                onClick={addCommodity}
              >
                Add Commodity
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}